import { render } from "./ReturnOrderDetailsComponent.vue?vue&type=template&id=6b4b4343"
import script from "./ReturnOrderDetailsComponent.vue?vue&type=script&lang=js"
export * from "./ReturnOrderDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/account/returnOrders/ReturnOrderDetailsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b4b4343"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b4b4343', __exports__)) {
    api.reload('6b4b4343', __exports__)
  }
  
  module.hot.accept("./ReturnOrderDetailsComponent.vue?vue&type=template&id=6b4b4343", () => {
    api.rerender('6b4b4343', render)
  })

}


export default __exports__